import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import * as actionCreators from '../../actions/additionalHorses';
import * as horseActionsCreators from '../../actions/nationHorses';
import * as feiIdActionCreators from '../../actions/feiId';
import { HorseList, CreateHorse } from '../../components/horse';

const mapStateToProps = (state, ownProps) => ({
  token: state.auth.token,
  isAdmin: state.auth.isAdmin,
  nation: ownProps.params.nation || state.auth.nation,
  horses: state.additionalHorses.horses,
  isPushingData: state.additionalHorses.isPushingData,
  isDeletingData: state.additionalHorses.isDeletingData,
  athlete: state.feiId.athlete,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actionCreators, dispatch),
  horseActions: bindActionCreators(horseActionsCreators, dispatch),
  feiIdActions: bindActionCreators(feiIdActionCreators, dispatch),
});

class HorseManagement extends Component {
  static propTypes = {
    token: PropTypes.string.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    nation: PropTypes.string.isRequired,
    horses: PropTypes.array.isRequired,
    actions: PropTypes.object.isRequired,
    isPushingData: PropTypes.bool.isRequired,
    isDeletingData: PropTypes.bool.isRequired,
    athlete: PropTypes.object.isRequired,
    feiIdActions: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    const { nation } = this.props;

    this.state = {
      filters: {
        nation: nation === 'ADMIN' || !nation ? undefined : nation,
      },
    };
  }

  componentWillMount() {
    const { filters } = this.state;

    this.fetchData(filters);
  }

  fetchData(filters) {
    const { token, actions } = this.props;

    actions.fetchHorses(token, { filters });
  }

  fetchAthleteByFeiId = (feiId, type) => {
    const { token, feiIdActions } = this.props;

    return feiIdActions.fetchAthleteByFeiId(token, feiId, type);
  };

  addHorse = horse => {
    const { token, horseActions } = this.props;

    horseActions.addHorse(horse, token);
  };

  createHorse = horseData => {
    const { token, actions } = this.props;

    return actions.createHorse(token, horseData);
  };

  deleteHorse = horseId => {
    const { token, actions } = this.props;

    return actions.deleteHorse(token, horseId);
  };

  editHorse = (horseId, horseData) => {
    const { token, actions } = this.props;

    return actions.editHorse(token, horseId, horseData);
  };

  render() {
    const { horses, isPushingData, isDeletingData, isAdmin, nation, athlete } = this.props;

    return (
      <div>
        <Row>
          <Col xs={isAdmin ? 12 : 10}>
            <h3 style={{ marginBottom: isAdmin ? 0 : undefined }}>Additional Horses</h3>
            <h5>
              Only horses which are not already entered with vaulters could be entered in this
              section.
            </h5>
          </Col>

          <Col xs={2} xsOffset={isAdmin ? 10 : 0}>
            <CreateHorse
              onSubmitForm={this.createHorse}
              isPushingData={isPushingData}
              nation={nation}
              addHorse={this.addHorse}
              fetchAthleteByFeiId={this.fetchAthleteByFeiId}
              athlete={athlete}
              isAdmin={isAdmin}
            />
          </Col>
        </Row>

        <HorseList
          horses={horses}
          onDeleteHorse={this.deleteHorse}
          isDeletingData={isDeletingData}
          onEditHorse={this.editHorse}
          isPushingData={isPushingData}
          nation={nation}
          fetchAthleteByFeiId={this.fetchAthleteByFeiId}
          athlete={athlete}
          isAdmin={isAdmin}
          addHorse={this.addHorse}
        />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HorseManagement)


// WEBPACK FOOTER //
// ./src/components/horse/HorseManagement.js